import { inject, Injectable } from '@angular/core';
import {
  BookWidgetAem,
  HeaderFooterMachCoreContentService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { BookingFlightsAdapterService } from '../../adapters/booking-flights/booking-flights-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class BookingFlightsFacadeService {
  flightWidgetAdapter = inject(BookingFlightsAdapterService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  flightsWidget$ = new BehaviorSubject<BookWidgetAem | null>(null);

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content) => {
        this.flightsWidget$.next(this.flightWidgetAdapter.getContent(content));
      });
  }
}
